import { render, staticRenderFns } from "./FluxFondosClassicStep2.vue?vue&type=template&id=5dbd1410"
import script from "./FluxFondosClassicStep2.vue?vue&type=script&lang=js"
export * from "./FluxFondosClassicStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports